import React from 'react';
import { CircularProgress, Grid, Typography } from '@mui/material';

type PleaseWaitProps = {
  /**
   * Message to display with busy spinner
   */
  message: string;
}

/**
 * A busy spinner and message indicating user needs to wait
 */
const PleaseWait: React.FC<PleaseWaitProps> = ({ message }) => {
  return (
    <Grid container sx={{ marginTop: '2rem', marginBottom: '2rem' }}>
      <Grid item xs={12} sx={{ margin: 'auto' }}>
        <Typography sx={{ textAlign: 'center' }} variant="h2">
          <CircularProgress sx={{ marginRight: '2rem', marginTop: '4rem' }} />
          {message}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default PleaseWait;
